/**
 * Validación y formateo RUT chileno (módulo 11).
 *
 * Referencia: ver also `e2e/fixtures/rut-generator.ts` (generación backend compartida).
 * Esta versión es client-side — para feedback inline en formularios.
 */

export function cleanRut(rut: string): string {
  return rut.replace(/[^0-9kK]/g, '').toUpperCase()
}

/** Calcula dígito verificador esperado para el cuerpo (sin DV). */
function calcDv(body: string): string {
  let sum = 0
  let multiplier = 2
  for (let i = body.length - 1; i >= 0; i--) {
    sum += Number(body[i]) * multiplier
    multiplier = multiplier === 7 ? 2 : multiplier + 1
  }
  const mod = 11 - (sum % 11)
  if (mod === 11) return '0'
  if (mod === 10) return 'K'
  return String(mod)
}

export function isValidRut(input: string): boolean {
  const cleaned = cleanRut(input)
  if (cleaned.length < 2) return false
  const body = cleaned.slice(0, -1)
  const dv = cleaned.slice(-1)
  if (!/^\d+$/.test(body)) return false
  return calcDv(body) === dv
}

/** Formatea `123456789` → `12.345.678-9`. Entrada ya limpia o no. */
export function formatRut(input: string): string {
  const cleaned = cleanRut(input)
  if (cleaned.length < 2) return cleaned
  const body = cleaned.slice(0, -1)
  const dv = cleaned.slice(-1)
  const formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `${formatted}-${dv}`
}
